<template>
 <div id="demo">
    <div id="indemo">
        <div id="demo1">
  
            <!-- <table width="60px" border="0" align="left" cellpadding="0" cellspacing="5"> -->
            <table height="15px" border="0" align="left" cellpadding="0" cellspacing="5" v-for="(val,index) in images" :key="index">
                <tr>
                    <td>
                        <table height="100%" border="0" align="left" cellpadding="0" cellspacing="0">
                            <tr>
                                <td height="100%" align="center" valign="middle"><img :src="val.image"  height="15px" @load="init"/></td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>
        <div id="demo2"></div>
    </div>
</div>
</template>
<script>
 export default{
    props:{
        images:Array
    },
    data(){
        return {
    
        }
    },
    mounted(){
        // this.init();
    },
    methods:{
        init(){
            var speed=20; //数字越大速度越慢
            var tab=document.getElementById("demo");
            var tab1=document.getElementById("demo1");
            var tab2=document.getElementById("demo2");
            tab2.innerHTML=tab1.innerHTML;
            function Marquee(){
                if(tab2.offsetWidth-tab.scrollLeft<=0)
                    tab.scrollLeft-=tab1.offsetWidth
                else{
                    tab.scrollLeft++;
                }
            }
            if(this.timer){
                // clearInterval(this.timer);
                // this.timer = null;
            }
            else{
                this.timer=setInterval(Marquee,speed);
            }
        }
   
    },
    beforeDestroy(){
           clearInterval(this.timer);
            this.timer = null;
    }
 }
</script>
<style lang="scss" scoped>      
    #demo {
        background: #FFF;
        overflow:hidden;
        overflow-y:hidden ;
        // border: 0px dashed #CCC;
        width: 5000px;
    }
    #indemo {
        float: left;
        width: 2000%;
    }
    #demo1 {
        float: left;
    }
    #demo2 {
        float: left;
    }
    /* for Chrome */
    .inner-container::-webkit-scrollbar {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/TopImage.vue